import styled from 'styled-components'

export const Image = styled.div`
  width: auto;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`
